import type { ReactNode } from "react";

/** Availability pill with a pinging dot — the hero's first element. */
export function StatusPill({ children }: { children: ReactNode }) {
  return (
    <span className="border-accent-soft bg-accent-surface text-accent-strong inline-flex max-w-full items-center gap-2 rounded-full border px-3.5 py-2 text-sm font-medium backdrop-blur-md">
      <span className="relative flex size-2 shrink-0">
        <span className="absolute inset-0 rounded-full bg-emerald-500 opacity-60 [animation:ping-dot_1.2s_cubic-bezier(0,0,0.2,1)_infinite]" />
        <span className="relative size-2 rounded-full bg-emerald-500" />
      </span>
      <span className="truncate">{children}</span>
    </span>
  );
}
